"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26705],{

/***/ 94514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E$": function() { return /* binding */ TradingContainer; },
/* harmony export */   "Lb": function() { return /* binding */ FilterButton; },
/* harmony export */   "Lw": function() { return /* binding */ CancelButton; },
/* harmony export */   "NF": function() { return /* binding */ DiscoverButton; },
/* harmony export */   "_u": function() { return /* binding */ HeaderBox; },
/* harmony export */   "c7": function() { return /* binding */ ModalButtonContainerSecondary; },
/* harmony export */   "eL": function() { return /* binding */ PortfolioTable; },
/* harmony export */   "gM": function() { return /* binding */ HeaderContainer; },
/* harmony export */   "nO": function() { return /* binding */ DescInput; },
/* harmony export */   "pl": function() { return /* binding */ ModalTradingButton; },
/* harmony export */   "qD": function() { return /* binding */ ModalButtonContainer; },
/* harmony export */   "rq": function() { return /* binding */ AlertCancelButton; },
/* harmony export */   "wn": function() { return /* binding */ Filter; }
/* harmony export */ });
/* unused harmony exports CellLabel, SpinnerBox */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77148);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 20px;\n\n  :last-child {\n    border: unset;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  grid-template-columns: repeat(2, 2fr);\n  grid-template-rows: 2fr;\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n  background: white;\n  margin-bottom: 20px;\n  width: 100%;\n  border-radius: 4px;\n\n  ",
        " {\n    display: inline-block;\n    width: calc(100% / 3);\n    border-right: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n\n    p {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    :nth-child(3),\n    :nth-child(5) {\n      border-right: unset;\n    }\n    :nth-child(4),\n    :nth-child(5) {\n      border-bottom: unset;\n      width: 50%;\n    }\n  }\n\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    grid-template-rows: 1fr;\n    ",
        " {\n      display: block;\n      width: 100% !important;\n      border-right: 1px solid ",
        "!important;\n      border-bottom: none;\n\n      :last-child {\n        border-right: unset !important;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1250px;\n  cursor: pointer;\n  .ant-table-thead > tr > th {\n    height: 17px;\n    font-size: 14px;\n    border-top: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n  }\n\n  .ant-table-tbody > tr:last-child > td {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  .ant-pagination {\n    display: none;\n  }\n\n  .ant-table-thead > tr > th {\n    font-size: 14px;\n    border-top: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n\n    &:nth-child(1) {\n      border-left: 1px solid ",
        ";\n    }\n\n    &:nth-child(10) {\n      border-right: 1px solid ",
        ";\n    }\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td:not(.td-mobile) {\n    display: none;\n  }\n\n  .ant-table-content {\n    overflow-x: unset;\n  }\n\n  .ant-table-tbody > tr > td {\n    &:nth-child(1) {\n      border-left: 1px solid ",
        ";\n      font-family: var(--font-bold);\n    }\n\n    &:nth-child(10) {\n      border-right: 1px solid ",
        ";\n    }\n  }\n\n  .ant-table-tbody > tr > .td-mobile:first-child {\n    display: block;\n    width: 100vw;\n    border-width: 0;\n    height: 25px;\n  }\n\n  /* Invested column */\n  .ant-table-tbody > tr > td:nth-child(6) {\n    text-align: left !important;\n  }\n  /* Action column */\n  .ant-table-tbody > tr > td:last-child > div {\n    height: 37px;\n  }\n\n  .ant-table-tbody > tr > .td-mobile {\n    display: inline-block;\n    width: calc(100vw / 4);\n  }\n\n  ",
        " {\n    display: block;\n  }\n\n  .ant-table-empty .ant-table-tbody > tr > td {\n    border-right: 1px solid ",
        ";\n  }\n\n  .ant-table-row.empty-row {\n    cursor: default;\n    background-color: #f7f7f7;\n\n    > .ant-table-cell {\n      background-color: #f7f7f7;\n      border-right: none;\n      &:nth-child(1) {\n        border-left: 1px solid ",
        ";\n        font-family: var(--font-bold);\n      }\n\n      &:nth-child(10) {\n        border-right: 1px solid ",
        ";\n      }\n    }\n  }\n\n  @media ",
        " {\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td:not(.td-mobile) {\n      display: table-cell;\n    }\n\n    .ant-table-content {\n      overflow-x: auto;\n    }\n\n    .ant-table-tbody > tr > .td-mobile:first-child,\n    .ant-table-tbody > tr > .td-mobile {\n      display: table-cell;\n      width: inherit;\n      border-width: 1px;\n    }\n\n    /* Invested column */\n    .ant-table-tbody > tr > td:nth-child(6) {\n      text-align: right !important;\n    }\n    /* Action column */\n    .ant-table-tbody > tr > td:last-child > div {\n      height: unset;\n    }\n\n    ",
        " {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n  height: 200px;\n  width: 100%;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 20px;\n  width: 20px;\n  padding: unset;\n\n  &[disabled] {\n    background: #dadada;\n    border: 1px solid #dadada;\n    color: #ffffff;\n\n    &:hover {\n      background: #dadada;\n      border: 1px solid #dadada;\n      color: #ffffff;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #f7f7f7;\n  height: 35px;\n  width: 75px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ::placeholder {\n    color: ",
        ";\n    font-family: var(--font-bold);\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 14px;\n  flex-direction: column;\n\n  > div:first-child {\n    margin-bottom: 10px;\n  }\n\n  @media ",
        " {\n    flex-direction: row;\n\n    > div {\n      margin-bottom: 0 !important;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 16px;\n  background: none;\n  border: none;\n  color: ",
        ";\n  border: 1px solid transparent;\n\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 17px;\n  cursor: pointer;\n\n  &.active {\n    border: 1px solid ",
        ";\n    border-radius: 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: 1px solid ",
        ";\n  max-width: 1250px;\n  background: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -60px;\n  left: 0px;\n  width: 100%;\n  gap: 12px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: 20px;\n  border-top: 1px solid #f1f1f1;\n  gap: 8px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 44px;\n  font-size: 16px;\n  color: ",
        " !important;\n  font-family: var(--font-bold);\n  background: ",
        ";\n  border-color: ",
        ";\n\n  &.sell {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n\n  &.exercise {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n\n  &.support {\n    background: ",
        ";\n    border-color: ",
        ";\n    font-size: 14px;\n  }\n\n  .icon-widget_support {\n    color: ",
        ";\n    margin-right: 5px;\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  &:disabled,\n  &:hover:disabled {\n    background: #616161;\n    border-color: #616161;\n    color: #cbcbcb;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: none;\n  padding: 6px 20px;\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n\n  &:hover {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}








var HeaderBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-6a1fbf3-0"
})(_templateObject());
var HeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6a1fbf3-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, HeaderBox, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__/* ["default"].tablet */ .Z.tablet, HeaderBox, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var CellLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].midgray */ .Z.midgray,
    size: "12px",
    align: "inherit"
}).withConfig({
    componentId: "sc-6a1fbf3-2"
})(_templateObject2());
var PortfolioTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Table__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, CellLabel, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__/* ["default"].mobileL */ .Z.mobileL, CellLabel);
var SpinnerBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-6a1fbf3-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var CancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    ml: "10px"
}).withConfig({
    componentId: "sc-6a1fbf3-5"
})(_templateObject5());
var AlertCancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-6"
})(_templateObject6());
var DescInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_5__/* ["default"].TextArea */ .Z.TextArea).withConfig({
    componentId: "sc-6a1fbf3-7"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var Filter = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-8"
})(_templateObject8(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__/* ["default"].mobileL */ .Z.mobileL);
var FilterButton = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6a1fbf3-9"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].midgray */ .Z.midgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary);
var TradingContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6a1fbf3-10"
})(_templateObject10(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light);
var ModalButtonContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-11"
})(_templateObject11());
var ModalButtonContainerSecondary = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-12"
})(_templateObject12());
var ModalTradingButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-13"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].dimGray */ .Z.dimGray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].dimGray */ .Z.dimGray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light);
var DiscoverButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a1fbf3-14"
})(_templateObject14(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary);


/***/ }),

/***/ 24949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getOrderDetail; },
/* harmony export */   "k": function() { return /* binding */ bulkCancelByOrderId; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4621);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96563);





var bulkCancelByOrderId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderIds) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_3__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__/* .orderEndpoint.bulkCancelByOrderId */ .Li.bulkCancelByOrderId, {
                        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateUiRef */ .TW)(),
                        order_id: orderIds
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function bulkCancelByOrderId(orderIds) {
        return _ref.apply(this, arguments);
    };
}();
var getOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_3__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__/* .orderEndpoint.orderDetail */ .Li.orderDetail, {
                        params: {
                            order_id: orderId
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 87127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12902);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75413);
/* harmony import */ var _api_order__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24949);








var initialState = {
    data: undefined,
    isLoading: false
};
var useOrderDetailStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadOrderDetail: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
                var axiosResponse, _data, responseData, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,_api_order__WEBPACK_IMPORTED_MODULE_2__/* .getOrderDetail */ .d)(orderId);
                        case 4:
                            axiosResponse = _ctx.sent;
                            _data = axiosResponse.data, responseData = _data.data;
                            data = utils_securities_transformData__WEBPACK_IMPORTED_MODULE_1__/* ["default"].orderDetail */ .Z.orderDetail(responseData);
                            set({
                                data: data,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(orderId) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetOrderDetail: function() {
            set(initialState);
        },
        updateOrderDetail: function(newData) {
            var ref;
            if (typeof newData !== "object") return;
            var currentOrderId = (ref = get().data) === null || ref === void 0 ? void 0 : ref.orderid;
            if (currentOrderId !== newData.orderid) return;
            set((0,immer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(state) {
                state.data = newData;
            }));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useOrderDetailStore);


/***/ }),

/***/ 98976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_usePortfolioDetailStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/securities/transformData.ts
var transformData = __webpack_require__(75413);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/portfolio.ts





var getPortfolio = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var targetAPI;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    targetAPI = (0,utils/* getTargetAPI */.Ai)();
                    return _ctx.abrupt("return", trading/* tradingApiInstance */.i[targetAPI].get(apiEndpoint/* portfolioEndpoint.portfolio */.Db.portfolio[targetAPI]));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPortfolio() {
        return _ref.apply(this, arguments);
    };
}();
var getPortfolioDetail = function(symbol) {
    var targetAPI = (0,utils/* getTargetAPI */.Ai)();
    return trading/* tradingApiInstance */.i[targetAPI].get(apiEndpoint/* portfolioEndpoint.portfolioDetail */.Db.portfolioDetail[targetAPI](symbol));
};

;// CONCATENATED MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts








var initialState = {
    data: {},
    dayTrade: {},
    isLoading: false
};
var usePortfolioDetailStore = (0,esm/* default */.ZP)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setCurrentSymbol: function(symbol) {
            set({
                data: {
                    symbol: symbol
                }
            });
        },
        loadPortfolioDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var axiosResponse, _data, responseData, result, day_trade, data, dataDaytrade;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return getPortfolioDetail(symbol);
                        case 4:
                            axiosResponse = _ctx.sent;
                            _data = axiosResponse.data, responseData = _data.data;
                            result = responseData.result, day_trade = responseData.day_trade;
                            data = transformData/* default.portfolioItem */.Z.portfolioItem(result);
                            dataDaytrade = transformData/* default.portfolioItem */.Z.portfolioItem(day_trade);
                            set({
                                data: data,
                                dayTrade: dataDaytrade,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetPortfolioDetail: function() {
            set(initialState);
        },
        updatePortfolioDetail: function(newData) {
            var checkSymbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref;
            if (typeof newData !== "object") return;
            var currentSymbol = (ref = get().data) === null || ref === void 0 ? void 0 : ref.symbol;
            if (currentSymbol !== newData.symbol && checkSymbol) return;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (isDayTrade) {
                    state.dayTrade = (0,_object_spread/* default */.Z)({}, state.dayTrade, newData);
                } else {
                    state.data = (0,_object_spread/* default */.Z)({}, state.data, newData);
                }
            }));
        }
    });
});
/* harmony default export */ var stores_usePortfolioDetailStore = (usePortfolioDetailStore);


/***/ }),

/***/ 29351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ VIRTUAL_TRADING_SOURCE; },
/* harmony export */   "SP": function() { return /* binding */ virtualTradingAction; },
/* harmony export */   "S_": function() { return /* binding */ SWITCH_TO_REAL_ACCOUNT_SOURCE; },
/* harmony export */   "Y0": function() { return /* binding */ ORDER_EXPIRY; },
/* harmony export */   "f9": function() { return /* binding */ virtualTradingNavigate; },
/* harmony export */   "gT": function() { return /* binding */ VIRTUAL_TRADING_TYPES; },
/* harmony export */   "ub": function() { return /* binding */ PORTFOLIOS_TYPE; }
/* harmony export */ });
/* unused harmony exports VIRTUAL_TRADING_NAVIGATE, VIRTUAL_TRADING_ACTION, SYMBOL_TYPES, ORDER_FILTER, virtualTradingEvents */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var VIRTUAL_TRADING_NAVIGATE = {
    buyOrderViewed: "Buy Order Viewed",
    portfolioViewed: "Portfolio Viewed",
    sellOrderViewed: "Sell Order Viewed",
    portfolioOrderViewed: "Portfolio Order Viewed",
    orderDetailViewed: "Order Detail Viewed",
    amendOrderViewed: "Amend Order Viewed"
};
var VIRTUAL_TRADING_ACTION = {
    virtualTradingAction: "Virtual Trading Action",
    startTradingSelected: "Start Trading Selected",
    virtualTradingSelected: "Virtual Trading Selected",
    switchToRealTradingSelected: "Switch To Real Trading Selected",
    virtualTradingOrderbookSelected: "Virtual Trading Orderbook Selected",
    virtualTradingPortfolioSelected: "Virtual Trading Portfolio Selected",
    virtualTradingOrderSelected: "Virtual Trading Order Selected",
    buyOrderPlaced: "Buy Order Placed",
    buyOrderCanceled: "Buy Order Canceled",
    portfolioBuyMoreSelected: "Portfolio Buy More Selected",
    portfolioSellStockSelected: "Portfolio Sell Stock Selected",
    portfolioViewChartSelected: "Portfolio View Chart Selected",
    portfolioSetPriceAlert: "Portfolio Set Price Alert Selected",
    portfolioStockSelected: "Portfolio Stock Selected",
    sellOrderPlaced: "Sell Order Placed",
    orderDetailCancelOrderSelected: "Order Detail Cancel Order Selected",
    orderDetailAmendSelected: "Order Detail Amend Selected",
    amendOrderPlaced: "Amend Order Placed"
};
var VIRTUAL_TRADING_TYPES = {
    virtualTrading: "Virtual Trading",
    realTrading: "Real Trading"
};
var SYMBOL_TYPES = {
    right: "Right",
    warrant: "Warrant",
    normal: "Normal"
};
var VIRTUAL_TRADING_SOURCE = {
    watchlist: "Watchlist",
    portfolio: "Portfolio",
    predictionPost: "Prediction Post",
    companyPage: "Company Page"
};
var SWITCH_TO_REAL_ACCOUNT_SOURCE = {
    orderModal: "Order Modal",
    dropdownVirtualArea: "Dropdown 'Virtual Area'"
};
var ORDER_FILTER = {
    order: "Order",
    exercise: "Exercise",
    cashback: "Cashback"
};
var ORDER_EXPIRY = {
    goodForDay: "Good for day",
    goodTillCanceled: "Good till canceled"
};
var PORTFOLIOS_TYPE = {
    regular: "Regular",
    dayTrade: "Day Trade",
    both: "Both",
    none: "None"
};
var virtualTradingEvents = {
    onSwitchToVirtualTrading: function() {
        var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Switch To Virtual Selected";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: action
        });
    }
};
var virtualTradingNavigate = {
    onBuyOrderViewes: function(Symbol, Source, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.buyOrderViewed, {
            Symbol: Symbol,
            Source: Source,
            Type: Type
        });
    },
    onPortfolioViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioViewed, {
            Type: Type
        });
    },
    onSellOrderViewed: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.sellOrderViewed, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioOrderViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioOrderViewed, {
            Type: Type
        });
    },
    onOrderDetailViewed: function(param) {
        var OrderType = param.OrderType, Status = param.Status, _RejectReason = param.RejectReason, RejectReason = _RejectReason === void 0 ? "" : _RejectReason, Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.orderDetailViewed, {
            "Order Type": OrderType,
            Status: Status,
            "Reject Reason": RejectReason,
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderViewed: function(param) {
        var Symbol = param.Symbol, OrderType = param.OrderType, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.amendOrderViewed, {
            Symbol: Symbol,
            "Order Type": OrderType,
            Type: Type
        });
    }
};
var virtualTradingAction = {
    onStartTradingSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.startTradingSelected
        });
    },
    onVirtualTradingSelected: function(isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingSelected,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onSwitchToRealTradingSelected: function(Source, isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.switchToRealTradingSelected,
            Source: Source,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onVirtualTradingOrderbookSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderbookSelected
        });
    },
    onVirtualTradingPortfolioSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingPortfolioSelected
        });
    },
    onVirtualTradingOrderSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderSelected
        });
    },
    onBuyOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.buyOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onBuyOrderCanceled: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.buyOrderCanceled,
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onPortfolioBuyMoreSelected: function(param) {
        var Symbol = param.Symbol, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioBuyMoreSelected, {
            Symbol: Symbol,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onPortfolioSellStockSelected: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSellStockSelected, {
            Type: Type
        });
    },
    onPortfolioViewChartSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioViewChartSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioSetPriceAlert: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSetPriceAlert, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioStockSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioStockSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onSellOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.sellOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onOrderDetailCancelOrderSelected: function(Symbol) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailCancelOrderSelected, {
            Symbol: Symbol
        });
    },
    onOrderDetailAmendSelected: function(param) {
        var Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailAmendSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.amendOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Type: Type
        });
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    virtualTradingEvents: virtualTradingEvents
});


/***/ }),

/***/ 62974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q7": function() { return /* binding */ isFloat; },
/* harmony export */   "QV": function() { return /* binding */ roundNumber; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "YA": function() { return /* binding */ parseNumberAbbrvNum; },
/* harmony export */   "rl": function() { return /* binding */ formatPercentage; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "ym": function() { return /* binding */ parseCountThousand; }
/* harmony export */ });
/* unused harmony exports kNumberFormatter, bNumberFormatter, decideNumberFormatter, parseCountAbbrv3, parseCountThousandWithDecimalPlace, parsePureValueSep */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-param-reassign */ /* eslint-disable arrow-body-style */ /* eslint-disable radix */ 
/*
  Count length of given decimal
*/ function countLengthDecimal(num) {
    var match = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(0, // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
    (match[2] ? +match[2] : 0));
}
/*
  Get random integer from in range of min to max value
*/ function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Get total digit of a number
 * @param {number} num
 */ function getNumberDigit(num) {
    var netral = Math.abs(num);
    return netral.toString().length;
}
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 */ function kNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComa = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / (nd > 5 ? 100000 : 1000)).toFixed(fixed);
        if (!withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else if (withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComa === "string" ? withComa : "0,0.00");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix M
 * @param {number} num - Long number
 * @param {number} fixed - Decimal
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function mNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number;
    var decide = false; // is decide need number
    if (getNumberDigit(num) > 6) decide = true;
    if (decide) {
        number = (num / 1000000).toFixed(fixed);
        if (symbol) {
            number += "M";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix B
 * @param {number} num - Long number
 * @param {number} fixed - Decimal number
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function bNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, formatDot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number = (num / 1000000000).toFixed(fixed);
    if (symbol) {
        if (formatDot) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0[.]0");
        }
        number += "B";
    }
    return number;
}
function tNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number = (num / 1000000000000).toFixed(fixed);
    if (symbol) {
        number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        number += "T";
    }
    return number;
}
/**
 * Function to decide which number formatter should be used based on
 * the number length
 * @param {number} num
 * @param {boolean} withThousands
 * @param {boolean} formatDot
 */ function decideNumberFormatter(num, withThousands, formatDot) {
    var numberDigit = getNumberDigit(num);
    if (numberDigit > 12 && formatDot) return tNumberFormatter;
    if (numberDigit > 9) return bNumberFormatter;
    if (withThousands) {
        if (numberDigit > 6) return mNumberFormatter;
        return kNumberFormatter;
    }
    return mNumberFormatter;
}
/**
 * Number formatter wrapper
 * @param {Object} params
 * @param {*} params.num - Number to be formatted
 * @param {number} params.fixed - Decimal place
 * @param {boolean=} params.symbol - If formatted number has symbol suffix
 * @param {boolean=} params.withThousands - If decided to format thousands number
 * @param {*=} params.formatDot - Using dot in formatting
 * @returns {string | number} -formatted number
 */ function numberFormatter(param) {
    var num = param.num, fixed = param.fixed, _symbol = param.symbol, symbol = _symbol === void 0 ? true : _symbol, _withThousands = param.withThousands, withThousands = _withThousands === void 0 ? false : _withThousands, _formatDot = param.formatDot, formatDot = _formatDot === void 0 ? false : _formatDot;
    var formatter = decideNumberFormatter(num, withThousands, Boolean(formatDot));
    return formatter(num, fixed, symbol, formatDot);
}
var char_count = function(str, letter) {
    var letter_Count = 0;
    for(var position = 0; position < str.length; position += 1){
        if (str.charAt(position) === letter) {
            letter_Count += 1;
        }
    }
    return letter_Count;
};
var roundNumber = function(number, format) {
    var nFormat = format.split(".");
    var multiplier = 1;
    if (nFormat.length > 1) {
        var getDecimal = nFormat.pop();
        var decimal = char_count(getDecimal, "0");
        multiplier = Math.pow(10, decimal);
    }
    var nNumber = (number >= 0 ? Math.floor : Math.ceil)(number * multiplier) / multiplier;
    return nNumber;
};
var isFloat = function(n1) {
    return Number(n1) % 1 !== 0;
};
var processNumber = function(number, format, showTrailingZero) {
    var formattedNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(format);
    var roundingNumber = formattedNumber;
    var splitNumber = formattedNumber.split(".");
    var isDecimal = splitNumber.length > 1;
    if (!showTrailingZero) {
        if (isDecimal) {
            roundingNumber = formattedNumber.replace(/(\.0+|0+)$/, "");
        } else if (splitNumber.length) {
            // eslint-disable-next-line prefer-destructuring
            roundingNumber = splitNumber[0];
        }
    }
    return roundingNumber;
};
var formatNumber = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0,0", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return newNumber;
};
var formatPercentage = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0.00", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (number === Infinity) number = 0;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return "".concat(newNumber, "%");
};
var parseLot = function(lot) {
    return Math.round(lot / 100);
};
var parseCountAbbrv3 = function(number, decPlaces) {
    var abbreviation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, withDecimal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, withMinusSymbol = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var result = 0;
    var minus = false;
    var newNumber = number;
    // eslint-disable-next-line eqeqeq
    if (newNumber && newNumber.toString().indexOf("-") == 0) {
        minus = true;
    }
    newNumber = Math.ceil(newNumber);
    if (!decPlaces) decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    var abbrev;
    // Enumerate number abbreviations
    // eslint-disable-next-line default-case
    switch(abbreviation){
        case 1:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B",
                "T"
            ];
            break;
        case 2:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B"
            ];
            break;
        case 3:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M"
            ];
            break;
        case 4:
            // Enumerate number abbreviations
            abbrev = [
                "K"
            ];
            break;
    }
    // Go through the array backwards, so we do the largest first
    // eslint-disable-next-line no-plusplus
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= newNumber) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            newNumber = Math.round(newNumber * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (newNumber === 1000 && i < abbrev.length - 1) {
                newNumber = 1;
                // eslint-disable-next-line no-plusplus
                i++;
            }
            var format = withDecimal ? "0,0[.]0" : "0,0";
            newNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(newNumber).format(format);
            if (minus) {
                newNumber = withMinusSymbol ? "-".concat(newNumber) : "(".concat(newNumber, ")");
            }
            // Add the letter for the abbreviation
            newNumber += "".concat(abbrev[i]);
            break;
        }
    }
    if (number) {
        var numString = newNumber.toString();
        result = numString;
    }
    return result;
};
var isNum = function(n1) {
    return !Number.isNaN(parseFloat(n1)) && Number.isFinite(n1);
};
var addPlusOrMinus2 = function(value) {
    if (!isNum(value)) {
        return value;
    }
    var formattedValue = numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).value();
    var newValue = parseFloat(formattedValue);
    if (formattedValue !== 0) {
        newValue = formattedValue < 0 ? numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0") : "+".concat(numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0"));
    }
    return typeof newValue !== "string" ? String(newValue) : newValue;
};
var parseCountThousand = function(num, withdot) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    // let sep = ','
    try {
        if (withdot) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        }
        return removeCountDotThousand(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator));
    } catch (e) {
        return num;
    }
};
var parseCountThousandWithDecimalPlace = function(num) {
    var decimalPlace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // let sep = ','
    try {
        return removeCountDotThousand(num.toLocaleString());
    } catch (e) {
        return num;
    }
};
function parsePureValueSep(pv) {
    var thoSep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    // console.log('::-- parsePureValue ', {pv, thoSep})
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",", enableK = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number == 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += "".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            // console.log('::-- row raw ', parsePureValueSep(raw[0], thoSep));
            result = parsePureValueSep(raw[0], thoSep);
            if (raw[1] === "K" && !enableK) {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result, thoSep);
            } else {
                result = "".concat(result, " ").concat(raw[1]);
            }
        } else {
            result = number;
        }
    }
    //   if(number) {
    // result = number.replace('.', ',')
    //   }
    return result;
};
function parseNumberAbbrvNum(val, format) {
    var number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(val);
    var formatted = number.format(format);
    return formatted;
}
var parseCountAbbrv4 = function(param) {
    var value = param.value, decPlaces = param.decPlaces, _abbreviation = param.abbreviation, abbreviation = _abbreviation === void 0 ? 1 : _abbreviation, _withDecimal = param.withDecimal, withDecimal = _withDecimal === void 0 ? false : _withDecimal, _withMinusSymbol = param.withMinusSymbol, withMinusSymbol = _withMinusSymbol === void 0 ? false : _withMinusSymbol;
    return parseCountAbbrv3(value, decPlaces, abbreviation, withDecimal, withMinusSymbol);
};
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 * @param {boolean} withComma
 */ function kNumberFormatterV2(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComma = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / 1000).toFixed(fixed);
        if (!withComma) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComma === "string" ? withComma : "0,0.0");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
var numberFormat = function(param) {
    var value = param.value, decimals = param.decimals, _decimalPoint = param.decimalPoint, decimalPoint = _decimalPoint === void 0 ? "." : _decimalPoint, _thousandSeparator = param.thousandSeparator, thousandSeparator = _thousandSeparator === void 0 ? "," : _thousandSeparator;
    //  discuss at: http://phpjs.org/functions/number_format/
    // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: davook
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Theriault
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Michael White (http://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (http://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    //  revised by: Luke Smith (http://lucassmith.name)
    //    input by: Kheang Hok Chin (http://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (http://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56);
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: number_format(1000);
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0);
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'
    var newNumber = value;
    var newDecimals = decimals;
    newNumber = "".concat(newNumber).replace(/[^0-9+\-Ee.]/g, "");
    var number = !isFinite(+newNumber) ? 0 : +newNumber;
    var prec = !isFinite(+newDecimals) ? 0 : Math.abs(newDecimals);
    var sep = thousandSeparator;
    var dec = decimalPoint;
    var sum = "";
    var toFixedFix = function toFixedFix(num, precision) {
        var power = Math.pow(10, precision);
        return "".concat((Math.round(num * power) / power).toFixed(precision));
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    sum = (prec ? toFixedFix(number, prec) : "".concat(Math.round(n))).split(".");
    if (sum[0].length > 3) {
        sum[0] = sum[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((sum[1] || "").length < prec) {
        sum[1] = sum[1] || "";
        sum[1] += new Array(prec - sum[1].length + 1).join("0");
    }
    return sum.join(dec);
};
var removeCountDotThousand = function(num) {
    if (!num.includes(".")) return num;
    num = numberFormat({
        value: num,
        decimals: 2
    });
    // pembulatan next index
    return num;
};
var isDecimal = function(result) {
    if (result > Math.floor(result)) {
        return true;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    countLengthDecimal: countLengthDecimal,
    getRandomInt: getRandomInt,
    decideNumberFormatter: decideNumberFormatter,
    numberFormatter: numberFormatter,
    bNumberFormatter: bNumberFormatter,
    mNumberFormatter: mNumberFormatter,
    kNumberFormatter: kNumberFormatter,
    parseCountAbbrv3: parseCountAbbrv3,
    parseLot: parseLot,
    addPlusOrMinus2: addPlusOrMinus2,
    parseCountAbbrv4: parseCountAbbrv4,
    kNumberFormatterV2: kNumberFormatterV2,
    numberFormat: numberFormat,
    isDecimal: isDecimal,
    parseCountAbbrv2: parseCountAbbrv2
});


/***/ })

}]);